import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import WinnipegsCleanAirAuthority from "./sections/WinnipegsCleanAirAuthority";
import WhyChooseTrustedInspections from "./sections/WhyChooseTrustedInspections";
import ProfessionalPlumbingSolutions from "./sections/ProfessionalPlumbingSolutions";
import TheTrustedInspectionsAdvantage from "./sections/TheTrustedInspectionsAdvantage";
import ServiceAreas from "./sections/ServiceAreas";
import ReachOutToTheShop from "./sections/ReachOutToTheShop";
import CallToAction from "./sections/CallToAction";
import CompanyDirectory from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <WinnipegsCleanAirAuthority />
      <WhyChooseTrustedInspections />
      <ProfessionalPlumbingSolutions />
      <TheTrustedInspectionsAdvantage />
      <ServiceAreas />
      <ReachOutToTheShop />
      <CallToAction />
      <CompanyDirectory />
    </div>;
}